<?php

Namespace Model;

class Configuration {

    public static $config = array();

    public function variable($var) {
        $config = &self::$config;
        $config['ISOPHP_API_SERVER_URL'] = 'https://api.dev.videointerviews.cloud';
        $config['env_level'] = 'dev';
        if (isset($config[$var])) {
            return $config[$var];
        }
        return null;
    }
}



// WEBPACK FOOTER //
// core/app_vars.php